import  request from '@/server/request'
import { API_JAVA } from '@/utils/base'


/**
 * 查询企业表
 */
export async function apiGetEnterpriseList(params) {
  return request( API_JAVA+'/tmr/enterprise/list',{
    method: 'GET',
    params: params
  })
}
/**
 * 现货商城-查询二级品类
 */
export async function apiGetMallLevel2C(params) {
  return request( API_JAVA+'/jgw/jgwProduct/mall/level2C',{
    method: 'GET',
    params: params
  })
}
/**
 * 现货商城-查询三级品类
 */
export async function apiGetMallLevel3C(params) {
  return request( API_JAVA+'/jgw/jgwProduct/mall/level3C',{
    method: 'GET',
    params: params
  })
}
/**
 * 现货商城-查询规格型号
 */
export async function apiGetMallSku(params) {
  return request( API_JAVA+'/jgw/jgwProduct/mall/sku',{
    method: 'GET',
    params: params
  })
}
/**
 * 现货商城-查询货源地
 */
export async function apiGetMallArea(params) {
  return request(API_JAVA+ '/jgw/jgwProduct/mall/area',{
    method: 'GET',
    params: params
  })
}
/**
 * 现货商城-根据条件查询商品列表
 */
export async function apiGetMallList(params) {
  return request( API_JAVA+'/jgw/jgwProduct/mall/list',{
    method: 'GET',
    params: params
  })
}
/**
 * 现货商城-现货推荐
 */
export async function apiGetRecommendList(params) {
  return request( API_JAVA+'/jgw/jgwProduct/mall/recommend',{
    method: 'GET',
    params: params
  })
}

/**
 * 卖家中心-商品管理-商品详情
 */
export async function apiGetProductDetail(params) {
  return request(API_JAVA+ '/jgw/jgwProduct/'+ params.id,{
    method: 'GET',
    // params: params
  })
}
/**
 * 卖家中心-商品管理-新增商品
 */
export async function apiAddProduct(params) {
  return request(API_JAVA+ '/jgw/jgwProduct/add',{
    method: 'POST',
    data: params,
  })
}
/**
 * 卖家中心-商品管理-更新商品
 */
export async function apiUpdateProduct(params) {
  return request(API_JAVA+ '/jgw/jgwProduct/update',{
    method: 'POST',
    data: params,
  })
}
/**
 * 卖家中心-更新店铺
 */
export async function apiUpdateShop(params) {
  return request( API_JAVA+'/backstage/shop/update',{
    method: 'POST',
    data: params
  })
}
/**
  * 卖家中心-用户是否有店铺
 */
export async function apiShopUser(params) {
  return request( API_JAVA+'/backstage/shop/source/0',{
    method: 'GET',
    params: params,
  })
}

// /**
//   * 卖家中心-用户是否有店铺
//  */
// export async function apiShopUser(params) {
//   return request( API_JAVA+'/backstage/shopUser/relationSearch',{
//     method: 'POST',
//     data: params
//   })
// }
/**
 * 卖家中心-获取店铺详情
 */
export async function apiGetShopDetail(params) {
  return request( API_JAVA+'/backstage/shop/'+params.id,{
    method: 'GET',
    // params: params
  })
}
/**
 * 卖家中心-商品管理-查询所有已显示的三级品类列表
 */
export async function apiGetCategoryList(params) {
  return request(API_JAVA+ '/purchase/category/list',{
    method: 'GET',
    params: params
  })
}
/**
 * 卖家中心-商品管理-根据条件查询产品spu列表
 */
export async function apiGetSpuList(params) {
  return request(API_JAVA+ '/purchase/spu/list',{
    method: 'GET',
    params: params
  })
}
/**
 * 卖家中心-商品管理-查询所有spu及其属性信息（树形）
 */
export async function apiGetTreeOfSpuAndAttribute(params) {
  return request(API_JAVA+ '/purchase/spu/getTreeOfSpuAndAttribute',{
    method: 'GET',
    params: params
  })
}

/**
 * 卖家中心-商品管理-根据条件查询品牌列表
 */
export async function apiGetJgwProductBrandList(params) {
  return request(API_JAVA+ '/jgw/jgwProductBrand/list',{
    method: 'GET',
    params: params
  })
}
/**
 * 卖家中心-商品管理-根据条件查询产品属性列表
 */
export async function apiGetAttributeList(params) {
  return request(API_JAVA+ '/purchase/attribute/list',{
    method: 'GET',
    params: params
  })
}
/**
 * 卖家中心-新增商品-供应商列表查询
 */
export async function apiGetSupplierList(params) {
  return request( API_JAVA+'/erp/supplier/list',{
    method: 'POST',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js